import * as React from 'react'

import { inject, observer } from 'mobx-react'

import Localization from '../../localization/LocalizationManager'
import LocationIntegration, {
  KnownLocationIntegrationMetadataKeys,
} from '../../models/LocationObjects/LocationIntegration'
import GraphExecutorStore from '../../stores/domain/GraphExecutor.store'
import EventsStore from '../../stores/EventStore/Events.store'
import ProjectDateStore from '../../stores/ui/ProjectDate.store'
import { LineChart } from '../LazyLineChart'
import { Loader } from '../Loader'
import MaturixStationDetailsStore, {
  MATURIX_CHART_OPTIONS,
} from '../SitemapDraggableModalWrapper/components/MaturixStationDetailsStore.store'
import MapViewItemBase from '../SitemapHelpers/models/MapViewItemBase'
import GeneralMapPopup, { MapPopupBody } from './GeneralMapPopup'

interface IProps {
  item: MapViewItemBase
  onClose(): void
  graphExecutorStore?: GraphExecutorStore
  eventsStore?: EventsStore
  projectDateStore?: ProjectDateStore
}

@inject('graphExecutorStore', 'eventsStore', 'projectDateStore')
@observer
export default class MaturixStationMapPopup extends React.Component<IProps> {
  private store: MaturixStationDetailsStore

  public constructor(props: IProps) {
    super(props)
    this.store = new MaturixStationDetailsStore(
      props.eventsStore,
      props.graphExecutorStore,
      props.projectDateStore,
    )
  }

  public componentDidMount(): void {
    const { dataObject } = this.props.item
    this.store.loadData(
      (dataObject as LocationIntegration).metadata[
        KnownLocationIntegrationMetadataKeys.MonitoringId
      ],
    )
  }

  public componentDidUpdate(prevProps: IProps) {
    if (this.props.item.id !== prevProps.item.id) {
      const { dataObject } = this.props.item
      this.store.loadData(
        (dataObject as LocationIntegration).metadata[
          KnownLocationIntegrationMetadataKeys.MonitoringId
        ],
      )
    }
  }

  private renderLineChart(dataSet: any) {
    return (
      <div className="tw:px-2.5">
        <LineChart data={dataSet} options={MATURIX_CHART_OPTIONS} />
      </div>
    )
  }

  public render() {
    const { item, onClose } = this.props
    const { temperatureDataSet, strengthDataSet, isLoading, monitoring } =
      this.store

    return (
      <GeneralMapPopup item={item} onClose={onClose}>
        <MapPopupBody>
          {isLoading ? (
            <div className="tw:my-[30px]">
              <Loader hint={Localization.translator.loadingMonitoringData} />
            </div>
          ) : monitoring ? (
            <div>
              <p className="tw:text-body-lg tw:ml-[5px] tw:mt-[5px]">
                {Localization.translator.deviceId}: {monitoring.deviceId}
              </p>
              <p className="tw:text-body-lg tw:ml-[5px]">
                {Localization.translator.monitoringName}:{' '}
                {monitoring.monitoringName}
              </p>
              <p className="tw:text-body-lg tw:ml-[5px]">
                {Localization.translator.status}: {monitoring.status}
              </p>
              {!!temperatureDataSet && this.renderLineChart(temperatureDataSet)}
              {!!strengthDataSet && this.renderLineChart(strengthDataSet)}
            </div>
          ) : (
            <div className="tw:my-[30px]">
              <p className="tw:text-body-lg tw:ml-[5px]">
                {Localization.translator.noInformationAvailableOnThisMonitoring}
              </p>
            </div>
          )}
        </MapPopupBody>
      </GeneralMapPopup>
    )
  }
}
